function init(el) {

    let companyId = el.dataset.companyId;
    let listId = el.dataset.listId;

    const emailInput = el.querySelector('[data-ref="emailInput"]');
    const message = el.querySelector('[data-ref="message"]');

    el.addEventListener('submit', (e) => { 
        e.preventDefault();

        const email = emailInput.value;

        if (!email) {
            return;
        }

        fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${companyId}`, {
            method: 'POST',
            headers: {
            revision: '2026-07-15',
            accept: 'application/vnd.api+json',
            'content-type': 'application/vnd.api+json'
            },
            body: JSON.stringify({
                data: {
                    type: 'subscription',
                    attributes: {
                        profile: {
                            data: {
                                type: 'profile',
                                attributes: {
                                    email,
                                    subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } },
                                },
                            },
                        },
                    },
                    relationships: {
                        list: { data: { type: 'list', id: listId } },
                    },
                },
            }),
            
        })
        .then((res) => {
            if (!res.ok) {
                throw new Error(`Klaviyo responded with ${res.status}`);
            }

            el.reset();

            if (message) {
                message.textContent = 'Thanks for subscribing!';
                message.hidden = false;
                setTimeout(() => {
                    message.hidden = true;
                }, 5000)
            }
        })
        .catch((error) => {
            console.error('Newsletter subscribe failed:', error);
            if (message) {
                message.textContent = 'Something went wrong. Please try again.';
                message.hidden = false;
            }
        });
    });
}

document.querySelectorAll('[data-newsletter-form]').forEach(init);